import { render, staticRenderFns } from "./InfoTechCallback.vue?vue&type=template&id=2d534bff"
import script from "./InfoTechCallback.vue?vue&type=script&lang=js"
export * from "./InfoTechCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports